import { BASE_URL } from 'config';
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "./OrderDetails.css";

export default function OrderDetails() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("user-token");
        const response = await axios.get(
          `${BASE_URL}/administrator/orders/show/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setOrder(response.data.data);
      } catch (error) {
        setOrder(null);
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [id]);

  const translateStatus = (status) => {
    if (!status) return "-";
    switch (status.toLowerCase()) {
      case "pending":
        return "قيد الانتظار";
      case "done":
        return "مكتمل";
      case "completed":
        return "مكتمل";
      default:
        return status;
    }
  };

  const getStatusClass = (status) => {
    if (!status) return "";
    switch (status.toLowerCase()) {
      case "pending":
        return "status-pending";
      case "done":
      case "completed":
        return "status-completed";
      default:
        return "";
    }
  };

  const handlePrint = () => {
    if (!order) return;

    const printContent = generatePrintHTML();
    const printWindow = window.open("", "_blank", "width=1200,height=900");

    printWindow.document.write(`
      <!DOCTYPE html>
      <html dir="rtl">
      <head>
        <meta charset="UTF-8">
        <title>تقرير الطلب - ${order.id}</title>
        <style>${getPrintStyles()}</style>
      </head>
      <body>
        ${printContent}
        <script>
          window.onload = function() {
            window.print();
            window.onafterprint = function() {
              window.close();
            };
          };
        </script>
      </body>
      </html>
    `);

    printWindow.document.close();
  };

  const getPrintStyles = () => {
    return `
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        font-family: Arial, sans-serif;
        direction: rtl;
        padding: 0;
        background: white;
      }

      .print-container {
        max-width: 210mm;
        margin: 0 auto;
        padding: 20mm;
        background: white;
      }

      .paper-wrapper {
        border: 4px solid #000;
        padding: 30px;
        background: white;
      }

      .report-header {
        text-align: center;
        border-bottom: 3px solid #111;
        padding-bottom: 20px;
        margin-bottom: 30px;
      }

      .report-header h1 {
        font-size: 28px;
        font-weight: bold;
        color: #111;
        margin-bottom: 12px;
      }

      .report-header .subtitle {
        font-size: 16px;
        color: #666;
      }

      .section {
        margin-bottom: 30px;
      }

      .section-title {
        font-size: 20px;
        font-weight: bold;
        color: #111;
        margin-bottom: 16px;
        padding-bottom: 8px;
        
      }

      .divider {
        height: 2px;
        background-color: #e0e0e0;
        margin: 30px 0;
      }

      table {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
        margin-top: 16px;
      }

      th, td {
        border: 2px solid #000;
        padding: 12px;
        text-align: center;
        word-wrap: break-word;
      }

      th {
        background-color: #f5f5f5;
        font-weight: bold;
        color: #333;
        font-size: 15px;
      }

      .label-cell {
        font-weight: 600;
        color: #555;
      }

      .status-badge {
        display: inline-block;
        padding: 6px 16px;
        border-radius: 16px;
        font-size: 14px;
        font-weight: 500;
      }

      .status-pending {
        background-color: #fff3e0;
        color: #e65100;
        border: 1px solid #e65100;
      }

      .status-completed {
        background-color: #e8f5e9;
        color: #2e7d32;
        border: 1px solid #2e7d32;
      }

      .suborder-box {
        border: 2px solid #e0e0e0;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 24px;
        background-color: #fafafa;
        page-break-inside: avoid;
      }

      .store-title {
        font-size: 18px;
        font-weight: bold;
        color: #333;
        margin-bottom: 16px;
      }

      .summary-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
        margin-bottom: 20px;
      }

      .summary-card {
        background: white;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        padding: 16px;
        text-align: center;
      }

      .summary-label {
        display: block;
        font-size: 13px;
        color: #666;
        margin-bottom: 8px;
      }

      .summary-value {
        display: block;
        font-size: 18px;
        font-weight: bold;
        color: #333;
      }

      .product-image {
        width: 50px;
        height: 50px;
        object-fit: cover;
        border-radius: 4px;
      }

      .product-name {
        text-align: right;
        word-break: break-word;
      }

      .total-cell {
        font-weight: bold;
        color: #333;
      }

      .attributes-cell {
        font-size: 13px;
        text-align: right;
      }

      .report-footer {
        margin-top: 30px;
        padding-top: 16px;
        border-top: 2px solid #e0e0e0;
        text-align: center;
        font-size: 13px;
        color: #666;
      }

      @media print {
        @page {
          size: A4;
          margin: 15mm;
        }

        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }

        .print-container {
          padding: 0;
        }
      }
    `;
  };

  const generatePrintHTML = () => {
    const orderStore = getOrderStores(order);
    const locationParts = order.location ? order.location.split(" - ") : ["-", "-", "-"];

    const orderInfo = [
      { label: "رقم الطلب", value: order.id || "-" },
      { label: "الحالة", value: translateStatus(order.status), isStatus: true },
      { label: "تاريخ الإنشاء", value: order.date || "-" },
      { label: "طريقة الدفع", value: order.is_paid ? "مدفوع" : "غير مدفوع" },
      { label: "طريقة الشحن", value: order.shipping_method || "-" },
      { label: "تكلفة الشحن", value: order.shipping_cost || "-" },
      { label: "العملة", value: order.currency || "-" },
      { label: "الإجمالي", value: order.price || "-" },
      { label: "الضريبة", value: order.tax || "-" },
      { label: "الخصم", value: order.discount || "-" },
      { label: "الإجمالي النهائي", value: order.total || "-" },
    ];

    const customerInfo = [
      { label: "اسم العميل", value: order.name || "-" },
      { label: "رقم الجوال", value: order.phone || "-" },
      { label: "العنوان", value: order.addresse || "-" },
      { label: "الدولة", value: locationParts[0] },
      { label: "الولاية", value: locationParts[1] },
      { label: "المدينة", value: locationParts[2] },
    ];

    return `
      <div class="print-container">
        <div class="paper-wrapper">
          <!-- Header -->
          <div class="report-header">
            <h1>تقرير تفاصيل الطلب</h1>
            <div class="subtitle">
              رقم الطلب: <strong>${order.id}</strong> | تاريخ: <strong>${order.date}</strong>
            </div>
          </div>

          <!-- Order Information -->
          <div class="section">
            <div class="section-title">معلومات الطلب</div>
            <table>
              <thead>
                <tr>
                  <th style="width: 50%">البيان</th>
                  <th style="width: 50%">القيمة</th>
                </tr>
              </thead>
              <tbody>
                ${orderInfo
                  .map(
                    (item) => `
                  <tr> 
                    <td class="label-cell">${item.label}</td>
                    <td>
                      ${item.value}
                    </td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>
          </div>

          

          <!-- Customer Information -->
          <div class="section">
            <div class="section-title">معلومات العميل</div>
            <table>
              <thead>
                <tr>
                  <th style="width: 50%">البيان</th>
                  <th style="width: 50%">القيمة</th>
                </tr>
              </thead>
              <tbody>
                ${customerInfo
                  .map(
                    (item) => `
                  <tr>
                    <td class="label-cell">${item.label}</td>
                    <td>${item.value}</td>
                  </tr>
                `
                  )
                  .join("")}
              </tbody>
            </table>
          </div>

         

          <!-- Products Section -->
          <div class="section">
            <div class="section-title">تفاصيل المنتجات</div>
            ${orderStore
              .map(
                (sub) => `
              <div class="suborder-box">
                <div class="store-title">
                  المتجر: ${sub.store?.name_ar || sub.store?.name_en || sub.store?.id || sub.store}
                </div>

                <!-- Summary Grid -->
                <div class="summary-grid">
                  <div class="summary-card">
                    <span class="summary-label">الحالة</span>
                    <span class="summary-value">${translateStatus(sub.status)}</span>
                  </div>
                  <div class="summary-card">
                    <span class="summary-label">الإجمالي</span>
                    <span class="summary-value">${sub.total.toFixed(2)}</span>
                  </div>
                  <div class="summary-card">
                    <span class="summary-label">الضريبة</span>
                    <span class="summary-value">${sub.tax_total.toFixed(2)}</span>
                  </div>
                  <div class="summary-card">
                    <span class="summary-label">الخصم</span>
                    <span class="summary-value">${sub.total_discount.toFixed(2)}</span>
                  </div>
                </div>

                <!-- Products Table -->
                <table>
                  <thead>
                    <tr>
                      
                      <th style="width: 20%">اسم المنتج</th>
                      <th style="width: 10%">الكمية</th>
                      <th style="width: 12%">السعر</th>
                      <th style="width: 12%">الضريبة</th>
                      <th style="width: 12%">الخصم</th>
                      <th style="width: 12%">الإجمالي</th>
                      <th style="width: 12%">السمات</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${sub.items
                      ?.map((item) => {
                        const itemTax = (parseFloat(item.tax) * item.quantity).toFixed(2);
                        const itemDiscount = item.discount
                          ? (parseFloat(item.discount) * item.quantity).toFixed(2)
                          : "-";
                        const itemTotal = (
                          item.quantity * parseFloat(item.price) +
                          parseFloat(item.tax) * item.quantity -
                          (item.discount ? parseFloat(item.discount) * item.quantity : 0)
                        ).toFixed(2);

                        return `
                        <tr>
                          
                          <td class="product-name">${item.name || "-"}</td>
                          <td>${item.quantity || "-"}</td>
                          <td>${item.price || "-"}</td>
                          <td>${itemTax}</td>
                          <td>${itemDiscount}</td>
                          <td class="total-cell">${itemTotal}</td>
                          <td class="attributes-cell">
                            ${
                              (item.attributes || [])
                                .map(
                                  (attr) =>
                                    `${attr.attribute_value?.attribute?.name}: ${attr.attribute_value?.value}`
                                )
                                .join(" | ") || "-"
                            }
                          </td>
                        </tr>
                      `;
                      })
                      .join("")}
                  </tbody>
                </table>
              </div>
            `
              )
              .join("")}
          </div>

          <!-- Footer -->
          <div class="report-footer">
            تم إنشاء هذا التقرير بواسطة نظام البلد - ${new Date().toLocaleDateString("ar-SA")}
          </div>
        </div>
      </div>
    `;
  };

  const getOrderStores = (orderData) => {
    if (!orderData.items) return [];
    const groups = {};
    orderData.items.forEach((item) => {
      const storeName = item.store || "غير محدد";
      if (!groups[storeName]) {
        groups[storeName] = {
          store: { name_ar: storeName },
          status: orderData.status,
          items: [],
          total: 0,
          tax_total: 0,
          total_discount: 0,
        };
      }
      item.discount = item.discount || 0;
      const price = parseFloat(item.price) || 0;
      const tax = parseFloat(item.tax) || 0;
      const discount = parseFloat(item.discount) || 0;
      const lineSubTotal = item.quantity * price;
      const lineTax = item.quantity * tax;
      const lineDiscount = item.quantity * discount;
      groups[storeName].items.push(item);
      groups[storeName].total += lineSubTotal;
      groups[storeName].tax_total += lineTax;
      groups[storeName].total_discount += lineDiscount;
    });
    return Object.values(groups);
  };

  if (loading) return <div className="loading">جاري التحميل...</div>;
  if (!order) return <div className="error">تعذر جلب بيانات الطلب</div>;

  const orderInfo = [
    { label: "رقم الطلب", value: order.id || "-" },
    { label: "الحالة", value: translateStatus(order.status), isStatus: true },
    { label: "تاريخ الإنشاء", value: order.date || "-" },
    { label: "طريقة الدفع", value: order.is_paid ? "مدفوع" : "غير مدفوع" },
    { label: "طريقة الشحن", value: order.shipping_method || "-" },
    { label: "تكلفة الشحن", value: order.shipping_cost || "-" },
    { label: "العملة", value: order.currency || "-" },
    { label: "الإجمالي", value: order.price || "-" },
    { label: "الضريبة", value: order.tax || "-" },
    { label: "الخصم", value: order.discount || "-" },
    { label: "الإجمالي النهائي", value: order.total || "-" },
  ];

  const locationParts = order.location ? order.location.split(" - ") : ["-", "-", "-"];
  const customerInfo = [
    { label: "اسم العميل", value: order.name || "-" },
    { label: "رقم الجوال", value: order.phone || "-" },
    { label: "العنوان", value: order.addresse || "-" },
    { label: "الدولة", value: locationParts[0] },
    { label: "الولاية", value: locationParts[1] },
    { label: "المدينة", value: locationParts[2] },
  ];

  const orderStore = getOrderStores(order);

  return (
    <div className="order-details-container">
      <div className="header">
        <h1>تفاصيل الطلب</h1>
        <button className="print-button" onClick={handlePrint}>
          <span>طباعة التقرير</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z" />
          </svg>
        </button>
      </div>

      <div className="paper-container">
        {/* Header */}
        <div className="report-header">
          <h2>تقرير تفاصيل الطلب</h2>
          <p className="subtitle">
            رقم الطلب: <strong>{order.id}</strong> | تاريخ: <strong>{order.date}</strong>
          </p>
        </div>

        {/* Order Information */}
        <div className="section">
          <h3 className="section-title">معلومات الطلب</h3>
          <table className="info-table">
            <thead>
              <tr>
                <th style={{ width: "50%" }}>البيان</th>
                <th style={{ width: "50%" }}>القيمة</th>
              </tr>
            </thead>
            <tbody>
              {orderInfo.map((item, idx) => (
                <tr key={idx}>
                  <td className="label-cell">{item.label}</td>
                  <td>
                    {item.isStatus ? (
                      <span className={`status-badge ${getStatusClass(order.status)}`}>
                        {item.value}
                      </span>
                    ) : (
                      item.value
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Customer Information */}
        <div className="section">
          <h3 className="section-title">معلومات العميل</h3>
          <table className="info-table">
            <thead>
              <tr>
                <th style={{ width: "50%" }}>البيان</th>
                <th style={{ width: "50%" }}>القيمة</th>
              </tr>
            </thead>
            <tbody>
              {customerInfo.map((item, idx) => (
                <tr key={idx}>
                  <td className="label-cell">{item.label}</td>
                  <td>{item.value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Products Section */}
        <div className="section">
          <h3 className="section-title">تفاصيل المنتجات</h3>
          {orderStore.map((sub, idx) => (
            <div key={idx} className="suborder-box">
              <h4 className="store-title">
                المتجر: {sub.store?.name_ar || sub.store?.name_en || sub.store?.id || sub.store}
              </h4>

              {/* Store Summary */}
              <div className="summary-grid">
                <div className="summary-card">
                  <span className="summary-label">الحالة</span>
                  <span className="summary-value">{translateStatus(sub.status)}</span>
                </div>
                <div className="summary-card">
                  <span className="summary-label">الإجمالي</span>
                  <span className="summary-value">{sub.total.toFixed(2)}</span>
                </div>
                <div className="summary-card">
                  <span className="summary-label">الضريبة</span>
                  <span className="summary-value">{sub.tax_total.toFixed(2)}</span>
                </div>
                <div className="summary-card">
                  <span className="summary-label">الخصم</span>
                  <span className="summary-value">{sub.total_discount.toFixed(2)}</span>
                </div>
              </div>

              {/* Products Table */}
              <table className="products-table">
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>اسم المنتج</th>
                    <th style={{ width: "10%" }}>الكمية</th>
                    <th style={{ width: "12%" }}>السعر</th>
                    <th style={{ width: "12%" }}>الضريبة</th>
                    <th style={{ width: "12%" }}>الخصم</th>
                    <th style={{ width: "12%" }}>الإجمالي</th>
                    <th style={{ width: "12%" }}>السمات</th>
                  </tr>
                </thead>
                <tbody>
                  {sub.items?.map((item) => {
                    const itemTax = (parseFloat(item.tax) * item.quantity).toFixed(2);
                    const itemDiscount = item.discount
                      ? (parseFloat(item.discount) * item.quantity).toFixed(2)
                      : "-";
                    const itemTotal = (
                      item.quantity * parseFloat(item.price) +
                      parseFloat(item.tax) * item.quantity -
                      (item.discount ? parseFloat(item.discount) * item.quantity : 0)
                    ).toFixed(2);
                    return (
                      <tr key={item.id}>
                        <td className="product-name">{item.name || "-"}</td>
                        <td>{item.quantity || "-"}</td>
                        <td>{item.price || "-"}</td>
                        <td>{itemTax}</td>
                        <td>{itemDiscount}</td>
                        <td className="total-cell">{itemTotal}</td>
                        <td className="attributes-cell">
                          {(item.attributes || [])
                            .map(
                              (attr) =>
                                `${attr.attribute_value?.attribute?.name}: ${attr.attribute_value?.value}`
                            )
                            .join(" | ") || "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="report-footer">
          تم إنشاء هذا التقرير بواسطة نظام البلد - {new Date().toLocaleDateString("ar-SA")}
        </div>
      </div>
    </div>
  );
}
